import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const GlobeIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 21C16.971 21 21 16.971 21 12C21 7.029 16.971 3 12 3M12 21C7.029 21 3 16.971 3 12C3 7.029 7.029 3 12 3M12 21C13.657 21 15 16.971 15 12C15 7.029 13.657 3 12 3M12 21C10.343 21 9 16.971 9 12C9 7.029 10.343 3 12 3M4 15H20M4 9H20"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

GlobeIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(GlobeIcon);
